angular.module('bmsApp.trugreen.job').controller('TGCloseJobListCtrl',
    function ($state,
              $scope,
              $filter,
              $window,
              $timeout,
              $rootScope,
              $stateParams,
              TGVisitSvc,
			  $localStorage,
			  LicenseOptionsSvc,
			  $q) {

        function init() {
            self.dateRangeOptions = $scope.config.datePicker.range;
            self.dateRangeOptions.options.format = $scope.config.format.date.amShortDate;
            self.dateRangeOptions.options.opens = 'left';
            delete self.dateRangeOptions.options.ranges.Today;
            delete self.dateRangeOptions.options.ranges.Yesterday;
            $scope.TGCloseJobListCtrl.window = $window.innerWidth;

            let params = null;
			if (angular.isDefined($localStorage.tgCloseJobListParams)) {
				params = $localStorage.tgCloseJobListParams;
			}

			if (angular.isObject($stateParams.data)) {
				self.filterOptions.dateRange.startDate = $stateParams.data.startDate;
				self.filterOptions.dateRange.endDate = $stateParams.data.endDate;
				self.filterOptions.active = true;
				self.filterOptions.unclosed = true;
				params = null;
			}

			LicenseOptionsSvc.license().then(function (response) {
				$scope.licenseOptions = response.data.options;
			});

            getJobs(params);
        }

        function changeDate() {
            getJobs();
        }

        function changeOrder() {
            getJobs();
        }

        function filterApply() {
        	self.pan.page = 1; // reset to page 1
            getJobs();
        }

        function filterReset() {
            self.filterOptions = {
				dateRangeArray: {
                    startDate: moment().subtract(1, 'month').format(),
                    endDate: moment().format()
                },
                unclosed: true,
                search: "",
				quoteVisit: false,
				licences: null,
			};
        }

        function getJobs(param) {
			if(!self.loading){
				self.loading = true;
				let params = null;
				if (angular.isObject(param)) {
					params = param;
					self.filterOptions = param.filter;
					self.filterOptions.dateRangeArray = {
						startDate: moment(param.filter.dateRangeArray.startDate).format(),
						endDate: moment(param.filter.dateRangeArray.endDate).format(),
					};
					self.pan = {
						page: param.page,
						limit: param.limit,
						count: param.count,
					};
				}
				else {
					params = {
						page: self.pan.page,
						limit: self.pan.limit,
						count: self.pan.limit,
						sorting: {
							visit_date: self.order
						},
						filter: {
							dateRangeArray: self.filterOptions.dateRangeArray,
							unclosed: self.filterOptions.unclosed,
							search: self.filterOptions.search,
							licences: self.filterOptions.licences,
							active: true,
							converted: true,
						}
					};

					if (!params.filter.unclosed) {
						params.filter.unclosed = null;
					}
				}
				angular.extend(params.filter, {
					quoteVisit: false,
				});


				$localStorage.tgCloseJobListParams = params;
				TGVisitSvc.index(params).then(function (response) {
					self.visitsTotal = response.data.tg_visits_total;
					self.visitDates = $filter('groupBy')(response.data.tg_visits, 'visit_date');
					self.loading = false;
					//emit data to the sidebar
					$scope.$emit("CloseJobListSideData", {
						"totalVisits": self.visitsTotal,
						"visits": self.visitDates,
						"pan": self.pan
					});
					// Check if we've exceeded our page size, if we have, go back
					if (self.visitsTotal > 0 && !response.data.tg_visits.length) {
						self.pan.page = 1;
						getJobs();
					}
				});
			}
        }



        var self = $scope.TGCloseJobListCtrl = {
            methods: {
                init: init,
                changeDate: changeDate,
                changeOrder: changeOrder,
                filterApply: filterApply,
                filterReset: filterReset,
                getJobs: getJobs
            },
            filterOptions: {
				dateRangeArray: {
                    startDate: moment().subtract(1, 'month').format(),
                    endDate: moment().format()
                },
                unclosed: true,
				converted: 1,
                search: ""
            },
            visitDates: [],
            licenses: {},
            dateRangeOptions: null,
            shortInfo: {
                closed: 0
            },
            window: 0,
            pan: {
                page: 1,
                limit: 15,
                count: 15
            },
			order: 'asc',
            visitsTotal: 0,
			loading: false,
			jobTimeout: 800
        };

    });